import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'AttendanceCheckinRecords/List',
        method: 'post',
        data
    })
}

/** 管理后台：管理员为机手手动录入打卡 */
export const adminManualSaveApi = (data) => {
    return request({
        url: 'AttendanceCheckinRecords/adminManualSave',
        method: 'post',
        data
    })
}